<template>
	<b-card class="sa-card" header="Attività" header-tag="header" footer-tag="footer" title="">
		<b-row>
			<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
				<label class="sa-label-data">Nome:</label>
				<span>{{ jsonData.nome }}</span>
			</b-col>
			<b-col cols="3" xs="3" sm="3" md="3" lg="3" xl="3">
				<label class="sa-label-data">Tipo:</label>
				<span>{{ jsonData.tipoAttivita }}</span>
			</b-col>
			<b-col cols="4" xs="4" sm="4" md="3" lg="3" xl="3">
				<label class="sa-label-data">Priorità:</label>
				<priorita-colors :prioritaLabel="jsonData.descrizionePriorita"></priorita-colors>
			</b-col>
			<b-col cols="4" xs="4" sm="4" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Inizio:</label>
				<span>{{ formatDate(jsonData.dataOraInizio) }}</span>
			</b-col>
			<b-col cols="4" xs="4" sm="4" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Fine:</label>
				<span>{{ formatDate(jsonData.dataOraFine) }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Stato Attuale:</label>
				<stati-colors :statoLabel="jsonData.statoAttuale"></stati-colors>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Stato Data/Ora:</label>
				<span>{{ formatDateTime(jsonData.statoAttualeDataOra) }}</span>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Progresso:</label>
				<b-progress :max="numeroTask" height="2rem" animated>
					<b-progress-bar :label="`${((numeroTaskCompleti / numeroTask) * 100).toFixed(2)}%`" :value="numeroTaskCompleti"> </b-progress-bar>
				</b-progress>
				<!-- <b-progress :value="numeroTaskCompleti" :max="numeroTask" show-value show-progress animated></b-progress> -->
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Descrizione:</label>
				<span>{{ jsonData.descrizione }}</span>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note:</label>
				<span>{{ jsonData.note }}</span>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import PrioritaColors from "../utility/PrioritaColors.vue";
import StatiColors from "../utility/StatiColors.vue";
export default {
	mixins: [UtilityMixin],
	components: { PrioritaColors, StatiColors },
	data() {
		return {
			id: null,
			numeroTask: 0,
			numeroTaskCompleti: 0,
			pathResourceAttivitaTipi: "/gestioneattivitatipi",
			pathResource: "/gestioneattivitaattivita",
			tipoAttivitaOptions: [],
			tipoPrioritaOptions: [{ descrizione: "NORMALE" }, { descrizione: "MEDIA" }, { descrizione: "ALTA" }, { descrizione: "URGENTE" }],
			jsonData: { descrizione: "", attivita: null, dataOraInizio: null, dataOraFine: null, statoAttuale: "", priorita: "" },
		};
	},
	mounted() {
		this.loadAttivitaTipi();
		this.id = this.$route.params.id;
		if (this.id !== "-1") {
			this.loadData();
		}
	},
	watch: {
		jsonData: {
			handler(jsonData) {
				this.$emit("updateJsonData", jsonData);
			},
			deep: true,
		},
	},
	methods: {
		setProgress(items) {
			this.numeroTask = items.length;
			this.numeroTaskCompleti = items.filter((item) => item.statoAttuale === "COMPLETATA/O" || item.statoAttuale === "RILASCIATO").length;
		},
		loadAttivitaTipi() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResourceAttivitaTipi, {}, me.loadAttivitaTipiSuccess, me.loadAttivitaTipiError);
		},
		loadAttivitaTipiSuccess(response) {
			let me = this;
			me.tipoAttivitaOptions = response.data.data.list;
		},
		loadAttivitaTipiError(error) {
			console.log(error);
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.jsonData = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
